import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { WidgetComponent } from '../';
import { SubscriptionsService } from 'core/services/subscriptions.service';

@Component({
  selector: 'lms-credits-list-widget',
  templateUrl: './credits-list-widget.component.html',
  styleUrls: ['./credits-list-widget.component.scss']
})
export class CreditsListWidgetComponent implements WidgetComponent, OnInit, OnDestroy {
  @Input() data: any;
  public listId = 'DASHBOARD_EXPIRING_CREDITS_LIST' + Date.now();
  public bags: any;
  public listOptions: any; // = { sort: 'endDate', filters: { '$filter': 'endDate ge ' + new Date().toISOString() } };
  public filters: Map<string, string>;
  public isOpen = false;

  constructor(public subscriptionsService: SubscriptionsService) {}

  ngOnInit() {
    this.filters = new Map<string, string>().set('$filter', this.data.filter);
    this.listOptions = {
      hidePaginator: true,
      sort: this.data.sort,
      limit: 3,
      filters: this.filters,
      populate: 'client',
      aggregates: ['availableCredits']
    };
  }

  ngOnDestroy() {}

  setCollection(bags) {
    this.bags = bags;
  }

  toggleData() {
    this.isOpen = !this.isOpen;
  }
}
